


















import { computed, defineComponent } from '@vue/composition-api';
import { SelfBuildingSquareSpinner } from 'epic-spinners';
import {
    ChartBarIcon,
    CloudUploadIcon,
    DatabaseIcon,
    SearchIcon,
    ShareIcon,
    TemplateIcon,
} from '@vue-hero-icons/outline';
import { DashboardStatistic } from '../../interfaces';

const icons: Record<string, any> = {
    datasets: DatabaseIcon,
    results: ChartBarIcon,
    ingestion: CloudUploadIcon,
    analytics: ShareIcon,
    retrieval: SearchIcon,
};

export default defineComponent({
    name: 'MetricCard',
    components: {
        ChartBarIcon,
        CloudUploadIcon,
        DatabaseIcon,
        SearchIcon,
        SelfBuildingSquareSpinner,
        ShareIcon,
        TemplateIcon,
    },
    props: {
        item: { type: Object as () => DashboardStatistic, required: true },
        loading: { type: Boolean, default: false },
    },
    setup(props) {
        const icon = computed(() => icons[props.item.icon as string] ?? TemplateIcon);
        return { icon };
    },
});
